import { CELL_PLACEMENT_STATUS } from './cell-tire-rack-order'

interface StatusConfig {
  display: string
  backgroundColor: string
  statusColor: string
  textColor: string
}

// Status colors use CSS variables for theme support
// These are resolved at runtime via var(--variable-name)
const installationStatuses: { [key: string]: StatusConfig } = {
  completed: {
    display: 'Completed',
    backgroundColor: 'var(--status-completed-bg)',
    statusColor: 'var(--status-completed-accent)',
    textColor: 'var(--text-primary)',
  },
  on_site: {
    display: 'On Site',
    backgroundColor: 'var(--status-on-site-bg)',
    statusColor: 'var(--status-on-site-accent)',
    textColor: 'var(--text-primary)',
  },
  started: {
    display: 'Started',
    backgroundColor: 'var(--status-started-bg)',
    statusColor: 'var(--status-started-accent)',
    textColor: 'var(--text-primary)',
  },
  en_route: {
    display: 'En Route',
    backgroundColor: 'var(--status-en-route-bg)',
    statusColor: 'var(--status-en-route-accent)',
    textColor: 'var(--text-primary)',
  },
  cancelled_onsite: {
    display: 'Cancelled Onsite',
    backgroundColor: 'var(--status-cancelled-bg)',
    statusColor: 'var(--status-cancelled-accent)',
    textColor: 'var(--text-primary)',
  },
  cancelled: {
    display: 'Cancelled',
    backgroundColor: 'var(--status-cancelled-bg)',
    statusColor: 'var(--status-cancelled-accent)',
    textColor: 'var(--text-primary)',
  },
  almost_late: {
    display: 'Almost Late',
    backgroundColor: 'var(--status-almost-late-bg)',
    statusColor: 'var(--status-almost-late-accent)',
    textColor: 'var(--text-primary)',
  },
  late: {
    display: 'Late',
    backgroundColor: 'var(--status-late-bg)',
    statusColor: 'var(--status-late-accent)',
    textColor: 'var(--text-primary)',
  },
  technician_not_available: {
    display: 'Tech Not Available',
    backgroundColor: 'var(--status-tech-unavailable-bg)',
    statusColor: 'var(--status-tech-unavailable-accent)',
    textColor: 'var(--text-primary)',
  },
  scheduled: {
    display: 'Scheduled',
    backgroundColor: 'var(--status-scheduled-bg)',
    statusColor: 'var(--status-scheduled-accent)',
    textColor: 'var(--status-scheduled-text)',
  },
  pending_rescheduling: {
    display: 'Pending Rescheduling',
    backgroundColor: 'var(--status-scheduled-bg)',
    statusColor: 'var(--status-scheduled-accent)',
    textColor: 'var(--status-scheduled-text)',
  },
  fixed: {
    display: 'Fixed',
    backgroundColor: 'none',
    statusColor: 'var(--bg-secondary)',
    textColor: 'var(--text-primary)',
  },
}

const deliveryStatuses: { [key: string]: StatusConfig } = {
  completed: {
    display: 'Delivered',
    backgroundColor: 'var(--status-completed-bg)',
    statusColor: 'var(--status-completed-accent)',
    textColor: 'var(--text-primary)',
  },
  on_site: {
    display: 'Arrived',
    backgroundColor: 'var(--status-on-site-bg)',
    statusColor: 'var(--status-on-site-accent)',
    textColor: 'var(--text-primary)',
  },
  started: {
    display: 'Arrived',
    backgroundColor: 'var(--status-started-bg)',
    statusColor: 'var(--status-started-accent)',
    textColor: 'var(--text-primary)',
  },
  en_route: {
    display: 'Out for Delivery',
    backgroundColor: 'var(--status-en-route-bg)',
    statusColor: 'var(--status-en-route-accent)',
    textColor: 'var(--text-primary)',
  },
  cancelled_onsite: {
    display: 'Delivery Cancelled',
    backgroundColor: 'var(--status-cancelled-bg)',
    statusColor: 'var(--status-cancelled-accent)',
    textColor: 'var(--text-primary)',
  },
  cancelled: {
    display: 'Delivery Cancelled',
    backgroundColor: 'var(--status-cancelled-bg)',
    statusColor: 'var(--status-cancelled-accent)',
    textColor: 'var(--text-primary)',
  },
  almost_late: {
    display: 'Out for Delivery',
    backgroundColor: 'var(--status-almost-late-bg)',
    statusColor: 'var(--status-almost-late-accent)',
    textColor: 'var(--text-primary)',
  },
  late: {
    display: 'Out for Delivery',
    backgroundColor: 'var(--status-late-bg)',
    statusColor: 'var(--status-late-accent)',
    textColor: 'var(--text-primary)',
  },
  technician_not_available: {
    display: 'Driver Not Available',
    backgroundColor: 'var(--status-tech-unavailable-bg)',
    statusColor: 'var(--status-tech-unavailable-accent)',
    textColor: 'var(--text-primary)',
  },
  scheduled: {
    display: 'Delivery',
    backgroundColor: 'var(--status-scheduled-bg)',
    statusColor: 'var(--status-scheduled-accent)',
    textColor: 'var(--status-scheduled-text)',
  },
  pending_rescheduling: {
    display: 'Delivery Needs Rescheduling',
    backgroundColor: 'var(--status-scheduled-bg)',
    statusColor: 'var(--status-scheduled-accent)',
    textColor: 'var(--status-scheduled-text)',
  },
  fixed: {
    display: 'Fixed',
    backgroundColor: 'none',
    statusColor: 'var(--bg-secondary)',
    textColor: 'var(--text-primary)',
  },
}

const cellPlacementStatuses: { [key in CELL_PLACEMENT_STATUS]: StatusConfig } =
  {
    [CELL_PLACEMENT_STATUS.ALL_PLACED]: {
      display: 'All Placed',
      backgroundColor: 'var(--status-completed-bg)',
      statusColor: 'var(--status-completed-accent)',
      textColor: 'var(--text-primary)',
    },
    [CELL_PLACEMENT_STATUS.UNDERLOADED]: {
      display: 'Underloaded',
      backgroundColor: 'var(--status-on-site-bg)',
      statusColor: 'var(--status-on-site-accent)',
      textColor: 'var(--text-primary)',
    },
    [CELL_PLACEMENT_STATUS.OVERLOADED]: {
      display: 'Overloaded',
      backgroundColor: 'var(--status-late-bg)',
      statusColor: 'var(--status-late-accent)',
      textColor: 'var(--text-primary)',
    },
    [CELL_PLACEMENT_STATUS.ZERO_PLACED]: {
      display: 'Zero Placed',
      backgroundColor: 'var(--status-scheduled-bg)',
      statusColor: 'var(--status-scheduled-accent)',
      textColor: 'var(--status-scheduled-text)',
    },
  }

export { installationStatuses, deliveryStatuses, cellPlacementStatuses }
